import { FC, ReactElement } from 'react';

export const Header: FC = (): ReactElement => (
  <h3 className="header">
    To start using the application, you must complete the remaining steps.
  </h3>
);

export default Header;
